/* eslint-disable no-nested-ternary */
import React from 'react';
import { Node, View } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import Immutable from 'immutable';
import useValueForCurrentViewPort from '../../../../helpers/useValueForCurrentViewPort';

import {
  Container,
  Divider,
  SliderRelated,
} from '../../../../components';

import './style.scss';

const BasicPageRelatedItems = ({ relatedItems = Immutable.List(), id }) => {
  const { t } = useTranslation();
  const slidesToShow = useValueForCurrentViewPort(1, 1, 3, 3, 3);

  if (relatedItems.size === 0) return <></>;

  return (
    <>
      {relatedItems.size > 0 && <Divider className="related-divider" />}


      {relatedItems.size > 0 ? (

        relatedItems.size < 4 ? (
          <Container>
            <div className="PageRelated">
              <div className="row">
                <h2 className="col-12 SliderRelated__title">{t('others_also_viewed')}</h2>

                {relatedItems.map((item, index) => {

                  const itemEntity = item.getIn(['entity'], Immutable.Map());
                  const itemId = itemEntity.getIn(['nid', '0', 'value']);
                  const uuid = itemEntity.getIn(['uuid', 0, 'value']);
                  const langcode = itemEntity.getIn(['langcode', 0, 'value']);
                  const itemClassName = 'col-12 col-sm12 col-md-4 col-lg-4';

                  return (
                    <div key={`${uuid}:${langcode}`} className={itemClassName}>
                      <Node
                        id={itemId}
                        key={`${uuid}:${langcode}`}
                        isActivePath
                        entity={itemEntity}
                        viewMode="teaser"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </Container>
        ) : (
          <Container>
            <div className="PageRelated">
              <SliderRelated slidesToShow={slidesToShow} title={t('others_also_viewed')}>
                {relatedItems.map((item) => {
                  const itemId = item.getIn(['nid', '0', 'value']);
                  const uuid = item.getIn(['uuid', 0, 'value']);
                  const langcode = item.getIn(['langcode', 0, 'value']);
                  const itemEntity = item.getIn(['entity'], Immutable.Map());
                  const itemClassName = 'PageRelated__item';
                  return (
                    <div key={`${uuid}:${langcode}`} className={itemClassName}>
                      <Node
                        id={itemId}
                        key={`${uuid}:${langcode}`}
                        entity={itemEntity}
                        viewMode="teaser"
                        width="270"
                      />
                    </div>
                  );
                })}
              </SliderRelated>
            </div>
          </Container>
        )) : (
        <>
          <Divider className="related-divider" />
          <Container>
            <View id="related_pages" display="block_1" args={[id]} />
          </Container>
        </>
      )}
    </>
  );
};

export default BasicPageRelatedItems;
